import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CPPopupComponent } from "../../../../popup/cp-popup/cp-popup.component";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { STEP2 } from 'src/app/interfaces/motor';
import { CLIENTTYPE, CONSTANTS, COUNTRIES, GENDER, IDTYPE } from 'src/app/shared/enums/index.enum';
import { takeUntil, Subject } from 'rxjs';
import { NricService } from '@services/nric/nric.service';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SmeCertFormComponent } from '../sme-cert-form/sme-cert-form.component';
import { SstFormDetailsComponent } from '../sst-form-details/sst-form-details.component';
import { CustomerPartnerFormComponent } from '../customer-partner-form/customer-partner-form.component';
import moment from 'moment';
import { Store } from '@ngxs/store';
import { CALCULATE_PREMIUM, CANCEL_DRAFT, GET_SWITCH_SITE, SAVE_AS_DRAFT, SAVE_CUSTOMER_PARTNER, SET_CUSTOMER_PARTNER_SEARCH_TYPE, STORE_COVERAGE_TYPE, STORE_COVERAGE_VEHICLE_DETAILS, STORE_PREMIUM_CALCULATION_PAYLOAD } from '@store/sat-motor/sat-motor.action';
import { SimpleModalComponent } from '@shared/components/modal/simple-modal/simple-modal.component';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { emailValidator } from '@shared/classes/validators/email.validator';
import { SaveDraftModalComponent } from '@shared/components/modal/save-draft-modal/save-draft-modal.component';
import { ConfirmationModalComponent } from '@shared/components/modal/confirmation-modal/confirmation-modal.component';
import { SummaryPopupComponent } from 'src/app/popup/summary-popup/summary-popup.component';
import { CancelDraftModalComponent } from '@shared/components/modal/cancel-draft-modal/cancel-draft-modal.component';
import { CancelDraftSuccessModalComponent } from '@shared/components/modal/cancel-draft-success-modal/cancel-draft-success-modal.component';
import { RESET_ERROR_MESSAGE } from '@store/exception/error.action';
import { ErrorModalComponent } from '@shared/components/modal/error-modal/error-modal.component';

@Component({
  selector: 'app-customer-partner-incomplete',
  standalone: true,
  imports: [
    SharedModule,
    SmeCertFormComponent,
    SstFormDetailsComponent,
    CustomerPartnerFormComponent
  ],
  templateUrl: './customer-partner-incomplete.component.html',
  styleUrl: './customer-partner-incomplete.component.scss'
})
export class CustomerPartnerIncompleteComponent implements OnInit {
  @Input() dataSearch: STEP2.SearchDataStore;
  @Input() isCompOrCustInfoIncomplete: boolean;
  @Input() isContactInfoIncomplete: boolean;
  @Input() isCorrespondenceInfoIncomplete: boolean;
  @Input() eInvoiceConsent: boolean = false;
  @Input() autoRenewal: boolean = false;
  @Input() mkagAgent: any;
  @Input() cpDetails:any;
  @Input() lov: any;
  @Input() edocConsentInd: boolean = false;
  @Input() emarketingConsentInd: boolean;

  @Output() searchAgain: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() back = new EventEmitter();

  @ViewChild(CustomerPartnerFormComponent) cpFormChildComponent!: CustomerPartnerFormComponent;

  customerPartnerIncompleteForm: FormGroup;
  individual: boolean = true;
  company: boolean = false;
  sst: boolean = true;
  sme: boolean = true;
  componentDialogRef?: NxModalRef<CPPopupComponent>;
  componentDialogRefs?: NxModalRef<SummaryPopupComponent>;

  search_mode_address: boolean = true;
  infoMessageModal?: NxModalRef<SimpleModalComponent>;
  userInfo: any;
  hideSaveDraftBtn: boolean = false;
  isQuotationGenerated: any;
  isCoverNoteGenerated: any;
  isUpdateQuotation: any;
  confirmMessageModal?: NxModalRef<ConfirmationModalComponent>;
  isSaved: any;
  isRetrieveActiveQuotation: any;
  issuanceInfo: any;
  hideSearchAgain: boolean = false;
  cCentricInfo: any;
  isCCentricIssuance: boolean = false;
  isCoverageStepExist: boolean = false;

  getLabel = CONSTANTS.getIdLabel();

  unsubscribe$ = new Subject<void>();

  constructor(
    private readonly dialogService: NxDialogService,
    private fb: FormBuilder,
    private nricService: NricService,
    private router: Router,
    private store: Store
  ) {
  }

  ngOnInit() {
    this.issuanceInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step1?.issuance?.issuance);
    this.userInfo = this.store.selectSnapshot<any>(state => state.UserState.user);
    this.isSaved = this.store.selectSnapshot<any>((state) => state.SatMotorState?.draftDetails);
    let draftDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.draftDetails);
    let previousCpDetails = draftDetails?.clientPartner;
    this.isQuotationGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
    this.isCoverNoteGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data?.cnoteNo);
    this.isUpdateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.updateQuotation);
    this.isRetrieveActiveQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.retrieveQuotation);
    this.isCoverageStepExist = !!this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3);

    let isCancelReplace = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote?.cancelReplaceContractId);
    this.hideSaveDraftBtn = isCancelReplace || this.isQuotationGenerated || this.isCoverNoteGenerated || this.isUpdateQuotation || this.isRetrieveActiveQuotation ? true : false;
    this.hideSearchAgain = this.issuanceInfo?.cnoteType == "RN" ? true : false;

    this.cCentricInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState?.cCentricInfo);
    this.isCCentricIssuance = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.isCCentricIssuance);

    this.getDefaultCpDetailsData();

    this.customerPartnerIncompleteForm =this.fb.group({
      name:[this.cpDetails.clientName ? this.cpDetails.clientName : '', Validators.required],
      nationality: [this.cpDetails.clientNationality ? this.cpDetails.clientNationality : this.defaultNationality()],
      idType2:[this.cpDetails.idType2 ? this.cpDetails.idType2 : ''],
      idValue2:[this.cpDetails.idValue2 ? this.cpDetails.idValue2 : ''],
      tinNo:[this.cpDetails.clientTinNo ? this.cpDetails.clientTinNo : '', [Validators.pattern("^[a-zA-Z0-9]*$")]],
      gender:[this.cpDetails.clientGender ? this.cpDetails.clientGender : ''],
      maritalStatus:[this.cpDetails.clientMaritalStatus ? this.cpDetails.clientMaritalStatus : ''],
      dob:[this.cpDetails.clientDateofBirth ? this.cpDetails.clientDateofBirth : ''],
      age:[{value:this.cpDetails.clientAge ? this.cpDetails.clientAge : '', disabled : true}],
      mobileNoCode:[!this.cpDetails.updateCustomerPartner && this.cpDetails.clientMobileCode1 ? this.cpDetails.clientMobileCode1 :''],
      mobileNo:[!this.cpDetails.updateCustomerPartner && this.cpDetails.clientMobileNo1 ? this.cpDetails.clientMobileNo1 : ''],
      fixedLineNoCode:[!this.cpDetails.updateCustomerPartner && this.cpDetails.clientPartnerAddress.clientPhoneCode ? this.cpDetails.clientPartnerAddress.clientPhoneCode : ''],
      fixedLineNo:[!this.cpDetails.updateCustomerPartner && this.cpDetails.clientPartnerAddress.clientPhoneNo ? this.cpDetails.clientPartnerAddress.clientPhoneNo : ''],
      faxNoCode:[!this.cpDetails.updateCustomerPartner && this.cpDetails?.clientPartnerAddress?.clientFax1Code ? this.cpDetails.clientPartnerAddress.clientFax1Code : ''],
      faxNo:[!this.cpDetails.updateCustomerPartner && this.cpDetails?.clientPartnerAddress?.clientFax1No ? this.cpDetails.clientPartnerAddress.clientFax1No : ''],
      email:[!this.cpDetails.updateCustomerPartner && this.cpDetails.clientEmail ? this.cpDetails.clientEmail : '', emailValidator],
      showMapSwitcher:[true],
      unitNo:[this.cpDetails.clientPartnerAddress.clientUnitNo ? this.cpDetails.clientPartnerAddress.clientUnitNo : ''],
      address1:[this.cpDetails.clientPartnerAddress.clientAddress1Tmp ? this.cpDetails.clientPartnerAddress.clientAddress1Tmp : ''],// Validators.required],
      address2:[this.cpDetails.clientPartnerAddress.clientAddress2 ? this.cpDetails.clientPartnerAddress.clientAddress2 : ''],
      address3:[this.cpDetails.clientPartnerAddress.clientAddress3 ? this.cpDetails.clientPartnerAddress.clientAddress3 : ''],
      postCode:[this.cpDetails.clientPartnerAddress.clientPostcode ? this.cpDetails.clientPartnerAddress.clientPostcode : previousCpDetails?.clientPartnerAddress.clientPostcode, Validators.required],
      city:[{value: this.cpDetails.clientPartnerAddress.clientCity ? this.cpDetails.clientPartnerAddress.clientCity : previousCpDetails?.clientPartnerAddress.clientCity, disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      state:[{value: this.cpDetails.clientPartnerAddress.clientState ? this.cpDetails.clientPartnerAddress.clientState : previousCpDetails?.clientPartnerAddress.clientState, disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      country:[{value: this.getDefaultCountry(previousCpDetails), disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      addressType:[this.cpDetails.clientPartnerAddress.clientAddressType ? this.cpDetails.clientPartnerAddress.clientAddressType : this.getDefaultAddressType()],
      clientGeoLatitude: [this.cpDetails.clientPartnerAddress.clientGeoLatitude ? this.cpDetails.clientPartnerAddress.clientGeoLatitude : ''],
      clientGeoLongitude: [this.cpDetails.clientPartnerAddress.clientGeoLongitude ? this.cpDetails.clientPartnerAddress.clientGeoLongitude : ''],
      clientGeoPlaceId: [this.cpDetails.clientPartnerAddress.clientGeoPlaceId ? this.cpDetails.clientPartnerAddress.clientGeoPlaceId : ''],
      clientGeoPlusCode: [this.cpDetails.clientPartnerAddress.clientGeoPlusCode ? this.cpDetails.clientPartnerAddress.clientGeoPlusCode : ''],
      clientGeoFormattedAddress: [this.cpDetails.clientPartnerAddress.clientGeoFormattedAddress ? this.cpDetails.clientPartnerAddress.clientGeoFormattedAddress : ''],
      emarketingConsentInd: [this.emarketingConsentInd]
    });

    if(this.cpDetails?.clientPartnerAddress?.clientAddressType) {
      let existingAddressType = this.lov.clientAddressTypeList?.find(item => this.cpDetails.clientPartnerAddress.clientAddressType == item.code);
      if(!existingAddressType) {
        this.customerPartnerIncompleteForm.patchValue({
          addressType: this.getDefaultAddressType()
        });
      }
    }

    if(this.cCentricInfo && this.isCCentricIssuance && !draftDetails) {
      this.populateCCentricCPInfo();
    }
    
  }

  getDefaultCountry(previousCpDetails: any): string {
    const cpAddress = this.cpDetails?.clientPartnerAddress ?? null;

    if (!cpAddress && !previousCpDetails) {
        return '';
    }

    if (cpAddress?.clientPostcode) {
        return "MAL"; //AGIC-49492
    }

    const country = cpAddress?.clientCountry ?? previousCpDetails?.clientPartnerAddress?.clientCountry;
    return country ?? '';
  }

  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  restartSearch() {
    this.searchAgain.emit(true);
  }
  initAddressValidators(){
    let cp = this.customerPartnerIncompleteForm.getRawValue();
    if ([cp.unitNo, cp.address2, cp.address3].find((element) => element && element.length > 0)) {
      this.customerPartnerIncompleteForm.controls['address1'].setValidators(Validators.required);
      this.customerPartnerIncompleteForm.controls['address1'].updateValueAndValidity();
    } else {
      this.clearvalidatoraddr();
    }
    this.customerPartnerIncompleteForm.controls['postCode'].setValidators(Validators.required);
    this.customerPartnerIncompleteForm.controls['postCode'].updateValueAndValidity();
  }

  clearvalidatoraddr(){
    this.customerPartnerIncompleteForm.controls['address1'].clearValidators();
    this.customerPartnerIncompleteForm.controls['address1'].updateValueAndValidity();
  }


  openPopup(popup_type: any) {
    this.componentDialogRefs = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
  }

  nextPage() {
    this.initAddressValidators();
    let invalidField = [];

    let formValues = this.customerPartnerIncompleteForm.getRawValue();
    let custAge = formValues?.age;

    let validForm = this.cpFormChildComponent.validateForm();

    if(this.customerPartnerIncompleteForm.valid && validForm) {
      //connect to BE to save the not found customer info
      console.log("customer partner incomplete form data: ", this.customerPartnerIncompleteForm.getRawValue());

      if(this.cpDetails.idType1 === IDTYPE.OLD_IC && formValues.idType2 !== IDTYPE.NRIC) {
        this.openNricNotUpdatePopup();
        return;
      }

      if(!this.isCompany && formValues.age < 16) {
        this.openPopup("custAge");
        return;
      }
      if( (!this.isCompany) && (custAge < 16 || custAge > 99) ){
        this.openPopup("custAge");
        return;
      }

      const payload = this.generateSaveCPPayload();

      let previousCpDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step2);

      this.store.dispatch(new SAVE_CUSTOMER_PARTNER(payload)).subscribe(state => {
        if (state.ErrorState.detail.isError) {
          this.dialogService.open(ErrorModalComponent, {
            disableClose: true,
            width: "400px",  data: { e: state.ErrorState.detail },
          }).afterClosed().subscribe((result) => {
              this.store.dispatch(new RESET_ERROR_MESSAGE());
          });
        } else {
          let cpDetails = state.SatMotorState.motor.step2;
          if(cpDetails) {
            let coveragePremium = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium);
            let coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coverageType);
            if (coveragePremium && this.isCoverageStepExist && coverageType) {
              let calculatePremiumPayload = {
                ...coveragePremium,
                cngeNote: {
                  ...coveragePremium.cngeNote,
                  clientPartner: cpDetails
                },
                operator: this.userInfo.userId
              };
              this.store.dispatch(new STORE_PREMIUM_CALCULATION_PAYLOAD(calculatePremiumPayload)).subscribe(() => {
                this.store.dispatch(new CALCULATE_PREMIUM(calculatePremiumPayload)).subscribe((stateLevel2) => {
                  let cngeNote =  stateLevel2?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
                  let vehicleDetail = this.store.selectSnapshot<any>((state) => state?.SatMotorState?.motor?.step3?.coverage?.vehicleDetails);
                  let ismRefNo = cngeNote?.riskList[0]?.ismRefNo || state.SatMotorState?.motor?.step3?.coverage?.ncdInfo?.ismRefNo;
                  let cngeNoteriskList = {
                    ...vehicleDetail,
                    riskType: "VEH",
                    ...(ismRefNo !== null && ismRefNo !== undefined ? { ismRefNo } : {}),
                  };

                  if (cngeNote?.riskList?.[0]) {
                    this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(cngeNoteriskList));
                    if (cngeNote?.riskList?.[0]?.coverList?.[0]) {
                      this.store.dispatch(new STORE_COVERAGE_TYPE(cngeNote?.riskList?.[0]?.coverList?.[0]));
                    }
                  }
                  this.store.dispatch(new SET_CUSTOMER_PARTNER_SEARCH_TYPE("FOUND"));
                  this.router.navigate(['issuance/coverage']);
                });
              });
            } else {
              this.store.dispatch(new SET_CUSTOMER_PARTNER_SEARCH_TYPE("FOUND"));
              this.router.navigate(['issuance/coverage']);
            }
            
          }
        }
      })
    }else {
      Object.keys(this.customerPartnerIncompleteForm.controls).forEach(a => {
        const control = this.customerPartnerIncompleteForm.get(a);
        if(control.invalid) {
          invalidField.push(a);
        }
      });
      this.customerPartnerIncompleteForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
      console.log("Invalid Field: ", invalidField);
    }
  }

  generateSaveCPPayload() {
    const formValue = this.customerPartnerIncompleteForm.getRawValue();
    const searchCriteria = this.store.selectSnapshot(state => state.SatMotorState.data.step2.search);
    const date = new Date();
    const effectiveDate = moment(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`, 'YYYY-M-D').format('YYYY-MM-DD');
    const user = this.store.selectSnapshot<string>((state) => state.UserState.user.userId);

    const payload = {
      clientPartner: {
        partnerId: this.cpDetails?.partnerId ?? null,
        partnerVersionNo: this.cpDetails?.partnerVersionNo ?? null,
        clientAge: formValue.age,
        clientDateofBirth: formValue.dob ? moment(formValue.dob, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientEmail: formValue.email,
        clientGender: formValue.gender,
        clientMobileCode1: formValue.mobileNoCode,
        clientMobileNo1: formValue.mobileNo,
        clientName: formValue.name,
        clientNationality: formValue.nationality,
        clientMaritalStatus: formValue.maritalStatus,
        clientPartnerAddress: {
          addressId: this.cpDetails?.clientPartnerAddress?.addressId ?? null,
          addressVersionNo: this.cpDetails?.clientPartnerAddress?.addressVersionNo ?? null,
          clientUnitNo: formValue.unitNo?.trim(),
          clientAddress1: formValue.address1?.trim(),
          clientAddress2: formValue.address2?.trim(),
          clientAddress3: formValue.address3?.trim(),
          clientAddressType: formValue.addressType,
          clientCity: formValue.city,
          clientCountry: formValue.country,
          clientPhoneCode: formValue.fixedLineNoCode,
          clientPhoneNo: formValue.fixedLineNo,
          clientFax1Code: formValue.faxNoCode,
          clientFax1No: formValue.faxNo,
          clientPostcode: formValue.postCode,
          clientState: formValue.state,
          clientGeoLatitude : formValue.clientGeoLatitude,
          clientGeoLongitude : formValue.clientGeoLongitude,
          clientGeoPlaceId : formValue.clientGeoPlaceId,
          clientGeoPlusCode : formValue.clientGeoPlusCode,
          clientGeoFormattedAddress : formValue.clientGeoFormattedAddress
        },
        clientType: this.cpDetails.clientType,
        defaultMailReq: false,
        idType1: this.cpDetails.idType1,
        idType2: formValue.idType2,
        idValue1: this.cpDetails.idValue1,
        idValue2: formValue.idValue2,
        updateCustomerPartner: false,
        clientTinNo: formValue.tinNo,
        clientSstRegInd: formValue.sstRegisteredInd !== undefined ? (formValue.sstRegisteredInd === 'Y' ? true : false) : this.cpDetails.clientSstRegInd,
        clientSstRegNo: formValue.sstRegisteredInd !== undefined ? formValue.sstNo : this.cpDetails.clientSstRegNo,
        clientSstRegDate: formValue.sstRegisteredInd !== undefined ? (formValue.sstEffDate && moment(formValue.sstEffDate).isValid() ? moment(formValue.sstEffDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '') : this.cpDetails.clientSstRegDate,
        clientSstDeRegDate: formValue.sstRegisteredInd !== undefined ? (formValue.sstDeRegDate && moment(formValue.sstDeRegDate).isValid() ? moment(formValue.sstDeRegDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '') : this.cpDetails.clientSstDeRegDate,
        clientSstResidentStatus: formValue.sstRegisteredInd !== undefined ? formValue.sstResidentStatus : this.cpDetails?.clientSstResidentStatus,
        clientSstCountry: formValue.sstRegisteredInd !== undefined ? formValue.sstCountry : this.cpDetails.clientSstCountry,
        smeCategory: formValue.smeRegisteredInd !== undefined ? formValue.smeCategory : this.cpDetails.smeCategory,
        smeEndDate: formValue.smeRegisteredInd !== undefined ? (formValue.smeEndDate ? moment(formValue.smeEndDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '') : this.cpDetails.smeEndDate,
        smeRegisteredInd: formValue.smeRegisteredInd !== undefined ? (formValue.smeRegisteredInd === 'Y' ? true : false) : this.cpDetails.smeRegisteredInd,
        smeRegisteredNumber: formValue.smeRegisteredInd !== undefined ? formValue.smeRegNo : this.cpDetails.smeRegisteredNumber,
        smeStartDate: formValue.smeRegisteredInd !== undefined ? (formValue.smeStartDate ? moment(formValue.smeStartDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '') : this.cpDetails.smeStartDate,
        emarketingConsentInd: formValue.emarketingConsentInd
      },
      mkagAgent: this.mkagAgent,
      effectiveDate: effectiveDate,
      productType: 'MT',
      operator: user
    }

    return payload;
  }

  goBack() {
    this.back.emit();
  }

  saveAsDraft() {
    let validForm = this.cpFormChildComponent.validateForm();

    if(this.customerPartnerIncompleteForm.valid && validForm) {
      const payload = this.generateSaveCPPayload();
      this.store.dispatch(new SAVE_CUSTOMER_PARTNER(payload)).subscribe(state => {
        if (state.ErrorState.detail.isError) {
          this.dialogService.open(ErrorModalComponent, {
            disableClose: true,
            width: "400px",  data: { e: state.ErrorState.detail },
          }).afterClosed().subscribe((result) => {
              this.store.dispatch(new RESET_ERROR_MESSAGE());
          });
        } else {
          this.store.dispatch(new SAVE_AS_DRAFT({ userId: this.userInfo.userId })).subscribe(state => {
            if (!state?.SatMotorState?.saveAsDraftError) {
              let cpDetails = state.SatMotorState.motor.step2;
              if (cpDetails) {
                this.dialogService.open(SaveDraftModalComponent, {
                  ariaLabel: "A simple dialog",
                  showCloseIcon: false,
                  disableClose: true,
                  autoFocus: false,
                  width: '90vw',
                  maxWidth: '550px',
                  data: {
                    draftNo: state.SatMotorState.draftDetails.proposalNo,
                  },
                })
                .afterClosed().subscribe((result) => {
                  this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                    window.location.href = state.SatMotorState.data.switchSiteUrl;
                  });
                });
              }
            } else {
              this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
                showCloseIcon: false,
                disableClose: true,
                width: '95%',
                maxWidth: '400px',
                data: {
                  type: "e-Quotation Saved Failed",
                  message: state?.SatMotorState?.saveAsDraftError,
                  btnOkLabel: "OK",
                },
              });
            }
          })
        }
      });
      
    }else {
      this.customerPartnerIncompleteForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }
  }

  getDefaultAddressType() {
    return this.isCompany ? 'O' : 'R';
  }

  openNricNotUpdatePopup() {
    this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { 
        type: "Warning", 
        message: "NRIC not updated for Policyholder. Please update."
      },
    });
  }

  openAgeNotMetPopup() {
    this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { 
        type: "Warning", 
        message: "Minimum age of the client is not met."
      },
    });
  }

  cancelDraft() {

    this.dialogService.open(CancelDraftModalComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: '90vw',
      maxWidth: '550px',
    })
    .afterClosed().subscribe(result => {
      if (result) {
        const data = {
          operator: this.userInfo.userId,
          cngeNote: this.isSaved
        };
        this.store.dispatch(new CANCEL_DRAFT(data)).subscribe(state => {
          if (state) {
            this.dialogService.open(CancelDraftSuccessModalComponent, {
              showCloseIcon: false,
              disableClose: true,
              autoFocus: false,
              width: "95vh", 
              maxWidth: "350px",
              // data: { message: "Cancel Draft Success" },
            })
            .afterClosed().subscribe((result) => {
              this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                window.location.href = state.SatMotorState.data.switchSiteUrl;
              });       	      
            });
          }
        });
      }
    });

  }

  get isCompany() {
    return this.cpDetails.clientType === CLIENTTYPE.COMPANY;
  }

  hasCoverNoteAccess() {
    if (this.userInfo && this.userInfo.menuAccess) {
      if (this.userInfo.menuAccess.includes('SAT_MT_CN')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  defaultNationality() {
    return this.isCompany ? 'MAL' : '';
  }
  

  populateCCentricCPInfo() {
    let cCentricCPInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.cCentricInfo?.cngeNoteDto?.clientPartner) ??
      this.store.selectSnapshot<any>(state => state.SatMotorState?.cCentricInfo?.clientPartner);
    
    let updateCustomerPartner = this.cpDetails.updateCustomerPartner;

    if (cCentricCPInfo) {
      if (!this.cpDetails.clientName && cCentricCPInfo?.clientName) {
        this.customerPartnerIncompleteForm.get('name').setValue(cCentricCPInfo?.clientName);
      }

      if (cCentricCPInfo?.clientPartnerAddress?.clientPostcode && (!this.cpDetails.clientPostcode || updateCustomerPartner)) {
        let postcode = cCentricCPInfo?.clientPartnerAddress?.clientPostcode;
        if (postcode) {
          let isValidPostcode = this.lov.clientPostcodeList.some(a => a.code == postcode);
          if (isValidPostcode) {
            this.customerPartnerIncompleteForm.get('postCode').setValue(cCentricCPInfo?.clientPartnerAddress?.clientPostcode);
          }
        }
      }

      if (this.cpDetails.clientType === CLIENTTYPE.INDIVIDUAL
        && cCentricCPInfo?.clientMaritalStatus && !this.cpDetails.clientMaritalStatus) {
        let maritalStatus = cCentricCPInfo?.clientMaritalStatus;
        let isValidMaritalStatus = this.lov?.clientMaritalList.some(a => a.code == maritalStatus);
        if (isValidMaritalStatus) {
          this.customerPartnerIncompleteForm.get('maritalStatus').setValue(maritalStatus);
        }
      }

      if(cCentricCPInfo?.clientMobileNo1 && (!this.cpDetails.clientMobileNo1 || updateCustomerPartner)) {
        this.customerPartnerIncompleteForm.get('mobileNo').setValue(this.subString(cCentricCPInfo?.clientMobileNo1, 8));
      }

      if(cCentricCPInfo?.clientEmail && (!this.cpDetails.clientEmail || updateCustomerPartner)) {
        this.customerPartnerIncompleteForm.get('email').setValue(cCentricCPInfo?.clientEmail);
      }

      if (cCentricCPInfo?.clientPartnerAddress?.clientPhoneNo && (!this.cpDetails.clientPartnerAddress?.clientPhoneNo || updateCustomerPartner)) {
        this.customerPartnerIncompleteForm.get('fixedLineNo').setValue(this.subString(cCentricCPInfo?.clientPartnerAddress?.clientPhoneNo, 8));
      }

      if (cCentricCPInfo?.clientPartnerAddress?.clientAddress1 && !this.cpDetails.clientPartnerAddress?.clientAddress1) {
        this.customerPartnerIncompleteForm.get('address1').setValue(cCentricCPInfo?.clientPartnerAddress?.clientAddress1);
      }

      if (cCentricCPInfo?.clientPartnerAddress?.clientAddress2 && !this.cpDetails.clientPartnerAddress?.clientAddress2) {
        this.customerPartnerIncompleteForm.get('address2').setValue(cCentricCPInfo?.clientPartnerAddress?.clientAddress2);
      }

      if (cCentricCPInfo?.clientPartnerAddress?.clientAddress3 && !this.cpDetails.clientPartnerAddress?.clientAddress3) {
        this.customerPartnerIncompleteForm.get('address3').setValue(cCentricCPInfo?.clientPartnerAddress?.clientAddress3);
      }
    }

  }

  subString(value, max) {
    if (!value) {
      return null;
    }
    return value.length <= max ? value : value.slice(0, max);
  }

  getDefaultCpDetailsData() {
    if (this.cpDetails?.idType1 == IDTYPE.NRIC && !this.cpDetails?.clientDateofBirth) {
      let dateOfBirth = this.getCalculateDateOfBirth(this.cpDetails.idValue1);
      this.cpDetails = {
        ...this.cpDetails,
        clientDateofBirth: dateOfBirth
      };
    }
  }

  getCalculateDateOfBirth(value: string): Date | string {
    try {
      return this.nricService.getDateOfBirth(value);
    } catch (error) {
      console.log('Error calculating date of birth:', error);
      return null;
    }
  }
}
